import API from '../services/api';

const api = new API();

const URL_MFA_APP = '/api/2fa_app';
const URL_MFA_DEACTIVATE = '/api/2fa_deactivate';

export const getMFAMetadata = () =>
    api.getJson(URL_MFA_APP, {
        method: 'GET',
        credentials: 'include',
    });

export const activateMFA = mfaToken =>
    api.getJson(URL_MFA_APP, {
        method: 'POST',
        credentials: 'include',
        body: { mfa_token: mfaToken },
        unique: true,
    });

export const deactivateMFA = () =>
    api.getJson(URL_MFA_DEACTIVATE, {
        method: 'GET',
        credentials: 'include',
    });
